import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Individual icon imports for better tree-shaking
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faLifeRing } from '@fortawesome/free-solid-svg-icons/faLifeRing';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faExpand } from '@fortawesome/free-solid-svg-icons/faExpand';
import { faCube } from '@fortawesome/free-solid-svg-icons/faCube';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faFilm } from '@fortawesome/free-solid-svg-icons/faFilm';
import { faNetworkWired } from '@fortawesome/free-solid-svg-icons/faNetworkWired';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faFileVideo } from '@fortawesome/free-solid-svg-icons/faFileVideo';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faFlagCheckered } from '@fortawesome/free-solid-svg-icons/faFlagCheckered';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faCommentSlash } from '@fortawesome/free-solid-svg-icons/faCommentSlash';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faShareFromSquare } from '@fortawesome/free-solid-svg-icons/faShareFromSquare';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons/faFileCsv';
import { faFileLines } from '@fortawesome/free-solid-svg-icons/faFileLines';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';

// Add icons to library
library.add(
  faEdit,
  faPlus,
  faCircleQuestion,
  faLifeRing,
  faTrash,
  faPlay,
  faDownload,
  faUpload,
  faExclamationCircle,
  faSignOutAlt,
  faSignInAlt,
  faUserPlus,
  faVideo,
  faFile,
  faClock,
  faExpand,
  faCube,
  faSpinner,
  faCheck,
  faExclamationTriangle,
  faMinus,
  faTachometerAlt,
  faFilm,
  faNetworkWired,
  faChartLine,
  faFileVideo,
  faEye,
  faCaretDown,
  faBook,
  faFlagCheckered,
  faSync,
  faTimes,
  faSearch,
  faCommentSlash,
  faLink,
  faShareFromSquare,
  faFileCsv,
  faFileLines,
  faApple
);

export { FontAwesomeIcon };
